// extracted by mini-css-extract-plugin
export default {"openRoles":"f94ip5mqZDGXHnI5tHTb","h2":"ZkbLrChEq8FUfNeRDmNe","item":"uq6cHWJaURXjzvP9fd3c"};